module.exports = __webpack_public_path__ + "pcau/img/chenghand.6fd580cc.png";